"use strict";
/**
 *
 * Backdrop
 *
 * https://github.com/mui-org/material-ui/blob/f55f3a4f808d1756d11d056195978affe4f65d5b/packages/material-ui/src/Backdrop/Backdrop.js
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("../styles");
const Fade_1 = require("../Fade");
const styles = styles_1.createStyles({
    /* Styles applied to the root element. */
    root: {
        zIndex: -1,
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        // Remove grey highlight
        WebkitTapHighlightColor: 'transparent',
        // Disable scroll capabilities.
        touchAction: 'none',
    },
    /* Styles applied to the root element if `invisible={true}`. */
    invisible: {
        backgroundColor: 'transparent',
    },
});
const Backdrop = react_1.default.forwardRef(function Backdrop(props, ref) {
    const { children, classes, className, invisible = false, open, transitionDuration } = props, other = __rest(props, ["children", "classes", "className", "invisible", "open", "transitionDuration"]);
    return (react_1.default.createElement(Fade_1.Fade, Object.assign({ in: open, timeout: transitionDuration }, other),
        react_1.default.createElement("div", { className: clsx_1.default(classes.root, {
                [classes.invisible]: invisible,
            }, className), "aria-hidden": true, ref: ref }, children)));
});
if (process.env.NODE_ENV !== 'production') {
    Backdrop.displayName = 'Backdrop';
}
const StyledBackdrop = styles_1.withStyles(styles)(Backdrop);
exports.Backdrop = StyledBackdrop;
